import { Fragment, h } from "preact";
import Router, { type RoutableProps } from "preact-router";
import { ChatPage } from "./pages/chat/chatPage";
import { ConversationsPage } from "./pages/content/contentpage";
import { ProfilePage } from "./pages/profile/profilepage";
import { UploadPage } from "./pages/upload/uploadPage";
import { UsagePage } from "./pages/usage/usagepage";
import { NotFoundPage } from "./pages/notfound/notfound";
import { ToastViewer } from "uitoolkit";
import { globalUserState } from "state";
import { CalendarPage } from "./pages/calendar/calendar";
import { NotesPage } from "./pages/notes/notes";
import { useBodyStyle } from "hooks";
import { ModelsPage } from "./pages/models/models";
import { HomePage } from "./pages/home/home";

export function App(props: RoutableProps) {
    useBodyStyle("app");
    const userState = globalUserState.value;
    const features = userState.user?.features ?? [];
    return (
        <Fragment>
            <Router>
                {
                    // default page is either home or chat
                    -1 !== features.findIndex(n => n.id == "home") ? <HomePage path="/" /> : <ChatPage path="/" showSendButton={false} />
                }
                <ChatPage path="/chat/:conversationId?" showSendButton={false} />
                <ConversationsPage path="/content" />
                <ProfilePage path="/profile" />
                <UsagePage path="/usage" />
                <ModelsPage path="/models" />
                {
                    -1 !== features.findIndex(n => n.id == "home") ? <HomePage path="/home" /> : undefined
                }
                {
                    -1 !== features.findIndex(n => n.id == "calendar") ? <CalendarPage path="/calendar" /> : undefined
                }
                {
                    -1 !== features.findIndex(n => n.id == "notes") ? <NotesPage path="/note/:id?" /> : undefined
                }
                {
                    -1 !== features.findIndex(n => n.id == "upload") ? <UploadPage path="/upload" /> : undefined
                }
                <NotFoundPage default />
            </Router>
            <ToastViewer />
        </Fragment>
    );
}
